import { getChatUserIdFromIdentity } from '../../../features/realtime/realtime.helpers';
import { type ChatMessage } from '../../../features/chat/chat.types';
import {
  type RealtimeEvent,
  type RealtimeMessage,
} from '../../../features/realtime/realtime.types';

export const getMessage = (
  realtimeMessage: RealtimeMessage,
  event: RealtimeEvent,
): Omit<ChatMessage, 'isOwn'> => {
  const message = realtimeMessage.payload as ChatMessage;
  const content = message.content;
  const timestamp = event.created.getTime();
  const senderId = getChatUserIdFromIdentity(event.from);

  return { content, timestamp, senderId };
};
